// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Offers: list page, offer editor (AddOffers) and "create invoice from offer" modal.
   Every rule is scoped under one of the page/modal root classes. */

/* ---------- Offers list ---------- */
.offers-page .offers-list__client {
  overflow-wrap: anywhere;
}

.offers-page .offers-list__company {
  display: block;
  color: var(--ds-text-muted);
}

/* ---------- Offer editor (AddOffers) ---------- */
.offer-form .offer-lines {
  margin-top: var(--ds-space-5);
}

.offer-form .offer-line {
  padding-bottom: var(--ds-space-3);
  margin-bottom: var(--ds-space-3);
  border-bottom: 1px solid var(--ds-border-soft);
}

.offer-form .offer-line__footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: var(--ds-space-2);
}

.offer-form .offer-line__total {
  margin-inline-end: auto;
  font-weight: 600;
  color: var(--ds-text);
}

.offer-form .offer-line__total strong {
  font-size: 1.1em;
  color: var(--ds-brand-strong);
}

.offer-form .offer-line__remove {
  min-height: 40px;
}

.offer-form .offer-summary {
  margin-top: var(--ds-space-5);
  text-align: end;
}

@media (max-width: 767.98px) {
  /* Each position becomes a card: name full width, qty/unit/price in one row, total below. */
  .offer-form .offer-line {
    padding: var(--ds-space-3);
    border: 1px solid var(--ds-border);
    border-radius: var(--ds-radius-md);
    background: var(--ds-surface);
    box-shadow: var(--ds-shadow-xs);
  }

  .offer-form .offer-line__label {
    display: block;
    margin-bottom: var(--ds-space-1);
    font-size: 12px;
    color: var(--ds-text-2);
  }

  .offer-form .offer-line__total strong {
    font-size: 1.2em;
  }

  .offer-form .offer-summary {
    text-align: start;
  }
}

/* ---------- Create invoice from offer ---------- */
.offer-invoice-modal .offer-invoice__meta {
  margin-bottom: var(--ds-space-4);
  background: var(--ds-surface-muted);
  border-color: var(--ds-border-soft);
}

.offer-invoice-modal .offer-invoice__meta-sub,
.offer-invoice-modal .offer-invoice__duration {
  font-size: 12px;
  color: var(--ds-text-muted);
}

.offer-invoice-modal .offer-invoice__meta,
.offer-invoice-modal .offer-invoice-line__name {
  overflow-wrap: anywhere;
}

.offer-invoice-modal .offer-invoice__items {
  margin-top: var(--ds-space-2);
  margin-bottom: var(--ds-space-4);
}

.offer-invoice-modal .offer-invoice__items-head {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  gap: var(--ds-space-2);
  margin-bottom: var(--ds-space-2);
}

.offer-invoice-modal .offer-invoice__summary {
  margin-bottom: var(--ds-space-4);
}

.offer-invoice-modal .offer-invoice__summary-card {
  background: var(--ds-surface-muted);
  border-color: var(--ds-border);
}

.offer-invoice-modal .offer-invoice__summary-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: var(--ds-space-2);
  margin-bottom: var(--ds-space-2);
}

.offer-invoice-modal .offer-invoice__summary-row:last-child {
  margin-bottom: 0;
}

.offer-invoice-modal .offer-invoice__history {
  margin-top: var(--ds-space-5);
}

/* Phone cards for the item selection */
.offer-invoice-modal .offer-invoice-lines {
  display: flex;
  flex-direction: column;
  gap: var(--ds-space-3);
}

.offer-invoice-modal .offer-invoice-lines__all {
  display: flex;
  align-items: center;
  min-height: 40px;
}

.offer-invoice-modal .offer-invoice-line {
  padding: var(--ds-space-3);
  border: 1px solid var(--ds-border);
  border-radius: var(--ds-radius-md);
  background: var(--ds-surface);
  box-shadow: var(--ds-shadow-xs);
}

.offer-invoice-modal .offer-invoice-line--off {
  background: var(--ds-surface-muted);
}

.offer-invoice-modal .offer-invoice-line__head {
  display: flex;
  align-items: flex-start;
  gap: var(--ds-space-3);
  min-height: 40px;
}

.offer-invoice-modal .offer-invoice-line__head .ant-checkbox-wrapper {
  padding-block: var(--ds-space-1);
}

.offer-invoice-modal .offer-invoice-line__name {
  flex: 1;
  min-width: 0;
}

.offer-invoice-modal .offer-invoice-line__grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: var(--ds-space-2);
  margin-top: var(--ds-space-3);
}

.offer-invoice-modal .offer-invoice-line__label {
  display: block;
  margin-bottom: var(--ds-space-1);
  font-size: 12px;
  color: var(--ds-text-2);
}

.offer-invoice-modal .offer-invoice-line__value {
  display: block;
  font-weight: 500;
  overflow-wrap: anywhere;
}

.offer-invoice-modal .offer-invoice-line__hint {
  display: block;
  font-size: 12px;
  color: var(--ds-text-muted);
}

.offer-invoice-modal .offer-invoice-line__total {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: var(--ds-space-2);
  margin-top: var(--ds-space-3);
  padding-top: var(--ds-space-2);
  border-top: 1px solid var(--ds-border-soft);
}

.offer-invoice-modal .offer-invoice-line__total-value {
  font-size: 1.2em;
}
`, "",{"version":3,"sources":["webpack://./src/commons/Billing/Offers/Offers.css"],"names":[],"mappings":"AAAA;mEACmE;;AAEnE,sCAAsC;AACtC;EACE,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,2BAA2B;AAC7B;;AAEA,mDAAmD;AACnD;EACE,6BAA6B;AAC/B;;AAEA;EACE,iCAAiC;EACjC,gCAAgC;EAChC,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,2FAA2F;EAC3F;IACE,0BAA0B;IAC1B,kCAAkC;IAClC,kCAAkC;IAClC,6BAA6B;IAC7B,+BAA+B;EACjC;;EAEA;IACE,cAAc;IACd,gCAAgC;IAChC,eAAe;IACf,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA,oDAAoD;AACpD;EACE,gCAAgC;EAChC,mCAAmC;EACnC,mCAAmC;AACrC;;AAEA;;EAEE,eAAe;EACf,2BAA2B;AAC7B;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;EAC7B,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,mBAAmB;EACnB,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,mCAAmC;EACnC,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,uCAAuC;AACvC;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,kCAAkC;EAClC,kCAAkC;EAClC,6BAA6B;EAC7B,+BAA+B;AACjC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,gCAAgC;EAChC,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,sBAAsB;EACtB,6BAA6B;EAC7B,8BAA8B;EAC9B,2CAA2C;AAC7C;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":["/* Offers: list page, offer editor (AddOffers) and \"create invoice from offer\" modal.\n   Every rule is scoped under one of the page/modal root classes. */\n\n/* ---------- Offers list ---------- */\n.offers-page .offers-list__client {\n  overflow-wrap: anywhere;\n}\n\n.offers-page .offers-list__company {\n  display: block;\n  color: var(--ds-text-muted);\n}\n\n/* ---------- Offer editor (AddOffers) ---------- */\n.offer-form .offer-lines {\n  margin-top: var(--ds-space-5);\n}\n\n.offer-form .offer-line {\n  padding-bottom: var(--ds-space-3);\n  margin-bottom: var(--ds-space-3);\n  border-bottom: 1px solid var(--ds-border-soft);\n}\n\n.offer-form .offer-line__footer {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: var(--ds-space-2);\n}\n\n.offer-form .offer-line__total {\n  margin-inline-end: auto;\n  font-weight: 600;\n  color: var(--ds-text);\n}\n\n.offer-form .offer-line__total strong {\n  font-size: 1.1em;\n  color: var(--ds-brand-strong);\n}\n\n.offer-form .offer-line__remove {\n  min-height: 40px;\n}\n\n.offer-form .offer-summary {\n  margin-top: var(--ds-space-5);\n  text-align: end;\n}\n\n@media (max-width: 767.98px) {\n  /* Each position becomes a card: name full width, qty/unit/price in one row, total below. */\n  .offer-form .offer-line {\n    padding: var(--ds-space-3);\n    border: 1px solid var(--ds-border);\n    border-radius: var(--ds-radius-md);\n    background: var(--ds-surface);\n    box-shadow: var(--ds-shadow-xs);\n  }\n\n  .offer-form .offer-line__label {\n    display: block;\n    margin-bottom: var(--ds-space-1);\n    font-size: 12px;\n    color: var(--ds-text-2);\n  }\n\n  .offer-form .offer-line__total strong {\n    font-size: 1.2em;\n  }\n\n  .offer-form .offer-summary {\n    text-align: start;\n  }\n}\n\n/* ---------- Create invoice from offer ---------- */\n.offer-invoice-modal .offer-invoice__meta {\n  margin-bottom: var(--ds-space-4);\n  background: var(--ds-surface-muted);\n  border-color: var(--ds-border-soft);\n}\n\n.offer-invoice-modal .offer-invoice__meta-sub,\n.offer-invoice-modal .offer-invoice__duration {\n  font-size: 12px;\n  color: var(--ds-text-muted);\n}\n\n.offer-invoice-modal .offer-invoice__meta,\n.offer-invoice-modal .offer-invoice-line__name {\n  overflow-wrap: anywhere;\n}\n\n.offer-invoice-modal .offer-invoice__items {\n  margin-top: var(--ds-space-2);\n  margin-bottom: var(--ds-space-4);\n}\n\n.offer-invoice-modal .offer-invoice__items-head {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  align-items: center;\n  gap: var(--ds-space-2);\n  margin-bottom: var(--ds-space-2);\n}\n\n.offer-invoice-modal .offer-invoice__summary {\n  margin-bottom: var(--ds-space-4);\n}\n\n.offer-invoice-modal .offer-invoice__summary-card {\n  background: var(--ds-surface-muted);\n  border-color: var(--ds-border);\n}\n\n.offer-invoice-modal .offer-invoice__summary-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: var(--ds-space-2);\n  margin-bottom: var(--ds-space-2);\n}\n\n.offer-invoice-modal .offer-invoice__summary-row:last-child {\n  margin-bottom: 0;\n}\n\n.offer-invoice-modal .offer-invoice__history {\n  margin-top: var(--ds-space-5);\n}\n\n/* Phone cards for the item selection */\n.offer-invoice-modal .offer-invoice-lines {\n  display: flex;\n  flex-direction: column;\n  gap: var(--ds-space-3);\n}\n\n.offer-invoice-modal .offer-invoice-lines__all {\n  display: flex;\n  align-items: center;\n  min-height: 40px;\n}\n\n.offer-invoice-modal .offer-invoice-line {\n  padding: var(--ds-space-3);\n  border: 1px solid var(--ds-border);\n  border-radius: var(--ds-radius-md);\n  background: var(--ds-surface);\n  box-shadow: var(--ds-shadow-xs);\n}\n\n.offer-invoice-modal .offer-invoice-line--off {\n  background: var(--ds-surface-muted);\n}\n\n.offer-invoice-modal .offer-invoice-line__head {\n  display: flex;\n  align-items: flex-start;\n  gap: var(--ds-space-3);\n  min-height: 40px;\n}\n\n.offer-invoice-modal .offer-invoice-line__head .ant-checkbox-wrapper {\n  padding-block: var(--ds-space-1);\n}\n\n.offer-invoice-modal .offer-invoice-line__name {\n  flex: 1;\n  min-width: 0;\n}\n\n.offer-invoice-modal .offer-invoice-line__grid {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: var(--ds-space-2);\n  margin-top: var(--ds-space-3);\n}\n\n.offer-invoice-modal .offer-invoice-line__label {\n  display: block;\n  margin-bottom: var(--ds-space-1);\n  font-size: 12px;\n  color: var(--ds-text-2);\n}\n\n.offer-invoice-modal .offer-invoice-line__value {\n  display: block;\n  font-weight: 500;\n  overflow-wrap: anywhere;\n}\n\n.offer-invoice-modal .offer-invoice-line__hint {\n  display: block;\n  font-size: 12px;\n  color: var(--ds-text-muted);\n}\n\n.offer-invoice-modal .offer-invoice-line__total {\n  display: flex;\n  justify-content: space-between;\n  align-items: baseline;\n  gap: var(--ds-space-2);\n  margin-top: var(--ds-space-3);\n  padding-top: var(--ds-space-2);\n  border-top: 1px solid var(--ds-border-soft);\n}\n\n.offer-invoice-modal .offer-invoice-line__total-value {\n  font-size: 1.2em;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
